
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon100Like = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 100,
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.333 89H32.848c-4.335.002-8.064-3.042-8.89-7.257l-3.885-13.9c-3.457-9.712-1.952-14.88-.078-17.507a7.826 7.826 0 0 1 6.533-3.347h8.59a33.27 33.27 0 0 1 .359-10.537c2.088-8.274 6.663-8.635 8.527-8.408 2.916.356 5.572 2.872 5.572 5.28a15.851 15.851 0 0 0 4.278 11.86c4.351 4.31 12.204 5.464 12.283 5.475a2.152 2.152 0 0 1 1.84 2.43 2.166 2.166 0 0 1-2.453 1.824c-.38-.054-9.375-1.378-14.738-6.69a19.98 19.98 0 0 1-5.548-14.783 2.557 2.557 0 0 0-2.05-1.143c-1.385.056-2.694 2-3.502 5.198-1.106 4.381.024 11.221.035 11.29a2.134 2.134 0 0 1-.485 1.742 2.178 2.178 0 0 1-1.655.76H26.528a3.49 3.49 0 0 0-2.99 1.53c-.848 1.19-2.484 4.902.65 13.664.017.047.032.096.046.144l3.93 14.058c.017.062.032.124.043.187.409 2.22 2.363 3.834 4.642 3.833h10.484c7.983 0 18.634-1.76 20.94-4.116a2.184 2.184 0 0 1 3.067-.047c.86.826.882 2.186.048 3.038C63.055 88.004 48.197 89 43.333 89z",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.788 89H65.212A2.21 2.21 0 0 1 63 86.792V49.208c0-1.22.99-2.208 2.212-2.208h14.576A2.21 2.21 0 0 1 82 49.208v37.584A2.21 2.21 0 0 1 79.788 89z",
  fill: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M68 84h10V52H68zM43 22c-1.105 0-2-.927-2-2.071V14.07c0-1.144.895-2.071 2-2.071s2 .927 2 2.071v5.858C45 21.073 44.105 22 43 22zm11.03 7a2.027 2.027 0 0 1-1.956-1.478 2.015 2.015 0 0 1 .909-2.271l4.914-2.944a2.036 2.036 0 0 1 2.047-.06A2.018 2.018 0 0 1 61 23.994c.01.73-.377 1.407-1.011 1.772l-4.914 2.945A2.036 2.036 0 0 1 54.03 29zm-23.073 0c-.37 0-.733-.101-1.05-.291L24.96 25.75a2.022 2.022 0 0 1-.668-2.768 2.048 2.048 0 0 1 2.773-.708l4.945 2.958c.786.47 1.16 1.404.914 2.282A2.04 2.04 0 0 1 30.957 29z"
}))));

      const __svgRaw = "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill-rule=\"nonzero\" fill=\"none\">\r\n        <path d=\"M43.333 89H32.848c-4.335.002-8.064-3.042-8.89-7.257l-3.885-13.9c-3.457-9.712-1.952-14.88-.078-17.507a7.826 7.826 0 0 1 6.533-3.347h8.59a33.27 33.27 0 0 1 .359-10.537c2.088-8.274 6.663-8.635 8.527-8.408 2.916.356 5.572 2.872 5.572 5.28a15.851 15.851 0 0 0 4.278 11.86c4.351 4.31 12.204 5.464 12.283 5.475a2.152 2.152 0 0 1 1.84 2.43 2.166 2.166 0 0 1-2.453 1.824c-.38-.054-9.375-1.378-14.738-6.69a19.98 19.98 0 0 1-5.548-14.783 2.557 2.557 0 0 0-2.05-1.143c-1.385.056-2.694 2-3.502 5.198-1.106 4.381.024 11.221.035 11.29a2.134 2.134 0 0 1-.485 1.742 2.178 2.178 0 0 1-1.655.76H26.528a3.49 3.49 0 0 0-2.99 1.53c-.848 1.19-2.484 4.902.65 13.664.017.047.032.096.046.144l3.93 14.058c.017.062.032.124.043.187.409 2.22 2.363 3.834 4.642 3.833h10.484c7.983 0 18.634-1.76 20.94-4.116a2.184 2.184 0 0 1 3.067-.047c.86.826.882 2.186.048 3.038C63.055 88.004 48.197 89 43.333 89z\" fill=\"#222\"/>\r\n        <path d=\"M79.788 89H65.212A2.21 2.21 0 0 1 63 86.792V49.208c0-1.22.99-2.208 2.212-2.208h14.576A2.21 2.21 0 0 1 82 49.208v37.584A2.21 2.21 0 0 1 79.788 89z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n        <path fill=\"var(--theme-primary, #810ea9)\" d=\"M68 84h10V52H68zM43 22c-1.105 0-2-.927-2-2.071V14.07c0-1.144.895-2.071 2-2.071s2 .927 2 2.071v5.858C45 21.073 44.105 22 43 22zM54.03 29a2.027 2.027 0 0 1-1.956-1.478 2.015 2.015 0 0 1 .909-2.271l4.914-2.944a2.036 2.036 0 0 1 2.047-.06A2.018 2.018 0 0 1 61 23.994c.01.73-.377 1.407-1.011 1.772l-4.914 2.945c-.316.189-.677.289-1.045.289zM30.957 29c-.37 0-.733-.101-1.05-.291L24.96 25.75a2.022 2.022 0 0 1-.668-2.768 2.048 2.048 0 0 1 2.773-.708l4.945 2.958c.786.47 1.16 1.404.914 2.282A2.04 2.04 0 0 1 30.957 29z\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-100-like.39e27cb2ef3ff810681ea382e8dd763a.svg"),
        {
          React: SvgIcon100Like,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      